import { NavLink } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth';
import { cn } from '@/lib/cn';

const NAV_ITEMS = [
  { to: '/', label: 'Ventas', icon: 'payments' },
  { to: '/finance', label: 'Finanzas', icon: 'account_balance' },
  { to: '/inventory', label: 'Inventario', icon: 'inventory_2' },
  { to: '/anomalies', label: 'Anomalías', icon: 'warning' },
  { to: '/trends', label: 'Tendencias', icon: 'trending_up' },
  { to: '/predict', label: 'Predicción', icon: 'auto_awesome' },
  { to: '/upload', label: 'Carga', icon: 'cloud_upload' },
  { to: '/config', label: 'Configuración', icon: 'settings' },
] as const;

export default function Sidebar() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  return (
    <aside
      className={cn(
        'fixed left-0 top-0 h-full w-sidebar-width',
        'bg-surface border-r-2 border-outline z-50',
        'flex flex-col px-6 pt-6 pb-4 gap-6 overflow-y-auto custom-scrollbar',
      )}
    >
      {/* Brand */}
      <div className="flex items-center gap-3">
        <div
          className={cn(
            'w-12 h-12 flex items-center justify-center shrink-0',
            'bg-primary border-2 border-black',
            'shadow-[3px_3px_0_0_#000000]',
          )}
        >
          <span
            className="material-symbols-outlined text-2xl text-black"
            style={{ fontVariationSettings: "'FILL' 1" }}
          >
            restaurant_menu
          </span>
        </div>
        <div>
          <h1 className="font-condensed text-xl leading-none text-primary uppercase tracking-tight">
            Empanada
          </h1>
          <p className="font-mono text-[10px] uppercase tracking-widest text-secondary">
            BI / Kinetic
          </p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex flex-col gap-2 flex-1">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 px-4 py-3',
                'transition-all duration-150',
                isActive ? 'nav-pill-active' : 'nav-pill-inactive',
              )
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={cn(
                    'material-symbols-outlined text-xl',
                    isActive ? 'text-black' : 'text-text-muted',
                  )}
                >
                  {item.icon}
                </span>
                <span className="font-bold uppercase tracking-wider text-xs">
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* User card + logout */}
      <div className="pt-4 border-t-2 border-outline space-y-3">
        <div className="bg-surface-container border-2 border-outline p-3">
          <p className="font-mono text-[9px] uppercase tracking-widest text-secondary mb-1">
            // SESSION
          </p>
          <p className="font-bold text-text-bright text-sm">{user?.username}</p>
          <p className="font-mono text-[10px] text-text-muted uppercase">{user?.role}</p>
        </div>
        <button
          onClick={logout}
          className={cn(
            'w-full flex items-center gap-3 px-4 py-3',
            'border-2 border-outline text-text-muted cursor-pointer',
            'transition-colors duration-150',
            'hover:border-error hover:text-error',
          )}
        >
          <span className="material-symbols-outlined text-xl">logout</span>
          <span className="font-bold uppercase tracking-widest text-xs">Salir</span>
        </button>
      </div>
    </aside>
  );
}
